import {
  BaseStyle,
  Button,
  Crossmark,
  FormattedMessage,
  GlobalStyle,
  WLOrgConfigProvider,
  logger,
  readCookie,
  useDisclosure,
} from '@talos/kyoko';
import { ThemeProvider } from 'styled-components';
import { ErrorBoundaryWrapper, ErrorMessage, ErrorTitle } from '../../components/ErrorBoundary/styles';

import { useFallbackTheme } from '@src/hooks/useFallbackTheme';
import { envConfig } from '@src/utils/envConfig';
import { useEffect } from 'react';
import { defineMessages } from 'react-intl';
import { SupportModal } from '../../components/SupportModal';

const messages = defineMessages({
  title: {
    id: 'Unauthorized.title',
    defaultMessage: 'You are not authorized to view this page',
  },
  message: {
    id: 'Unauthorized.message',
    defaultMessage:
      'If this issue persists, please get in touch with support and we will resolve the problem as soon as possible.',
  },
  contactSupport: {
    id: 'Unauthorized.contactSupport',
    defaultMessage: 'Contact support',
  },
});

export const Unauthorized = () => {
  return (
    <WLOrgConfigProvider>
      <UnauthorizedContent />
    </WLOrgConfigProvider>
  );
};

const UnauthorizedContent = () => {
  const modalState = useDisclosure();
  const theme = useFallbackTheme();

  useEffect(() => {
    logger.info('[auth] Unauthorized page rendered', {
      extra: {
        cookie: readCookie(envConfig.VITE_SESSION_COOKIE),
      },
    });
  }, []);

  const handleOpenModal = () => {
    modalState.open();
  };

  if (!theme) {
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <BaseStyle />
      <GlobalStyle />
      <ErrorBoundaryWrapper>
        <div>
          <Crossmark />
          <ErrorTitle>
            <FormattedMessage {...messages.title} />
          </ErrorTitle>
          <ErrorMessage>
            <FormattedMessage {...messages.message} />
          </ErrorMessage>
          <p>
            <Button onClick={handleOpenModal}>
              <FormattedMessage {...messages.contactSupport} />
            </Button>
          </p>
        </div>
        <SupportModal {...modalState} />
      </ErrorBoundaryWrapper>
    </ThemeProvider>
  );
};
